import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// Replace only the legacy path. Recipient parameters and the fragment belong
// to the existing surface and must survive the canonical redirect.
export default function InboxLegacyRedirect({ section }) {
  const { search, hash } = useLocation();
  return <Navigate to={`/inbox/${section}${search}${hash}`} replace />;
}
